import React from 'react';
import PropTypes from 'prop-types';

import i18n from '../../i18n';
import { CurrencyFormatter } from '../../utils/Intl';

import Exchange from '../../models/Exchange';
import User from '../../models/User';
import { Icon } from '@homeexchange/design';

const SubscriptionRow = (props) => {
    const { user, exchange, currency, isGuest, isSubscriber = false } = props;
    const subscription = user.get('subscription');
    const isTrial = subscription?.is_trial;

    if (!isGuest || !exchange.hasSelectedSubscription() || (isSubscriber && !isTrial)) {
        return null;
    }

    let productPrice = exchange.get('product_selected').get('price');

    if (isTrial) {
        productPrice = subscription?.product?.price;
    }

    const price = i18n.t('common:price_per_year', {
        value: CurrencyFormatter.format(productPrice, currency)
    });
    const bonus = exchange.get('bonus_gp_subscription');

    return (
        <div className="form-group editable-field subscription-selected">
            <label>
                {i18n.t('exchange:messaging.purchase.membership.title')}
                <span className="value">
                    <span className="pull-right">{price}</span>
                </span>
            </label>
            {((!user?.get('subscription') && !user?.get('is_he_collection')) || isTrial) && bonus > 0 && (
                <div className="subscription-bonus">
                    <div className="subscription-bonus-title-container">
                        <Icon name="Gift" />
                        <p className="subscription-bonus-title">
                            {i18n.t('exchange:bonus-membership.title')}
                        </p>
                        <span className="subscription-bonus-gp">+{bonus}GP</span>
                    </div>
                </div>
            )}
            <div className="subscription_details">
                <div className="extra">
                    <p>{i18n.t('exchange:he.service.included')}</p>
                </div>
            </div>
        </div>
    );
};

SubscriptionRow.propTypes = {
    user: PropTypes.instanceOf(User).isRequired,
    currency: PropTypes.string.isRequired,
    exchange: PropTypes.instanceOf(Exchange).isRequired,
    isGuest: PropTypes.bool,
    isSubscriber: PropTypes.bool
};

export default SubscriptionRow;
